<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.gerenteRegional.labels.titulo")',
        :voltarPara='{ route: "GerentesRegionais" }'
    )
    .detalhes-gerente-regional
        h3.detalhes-gerente-regional__titulo {{ $t('mensagens.gerenteRegional.labels.dadosCadastrais') }}
        .detalhes-gerente-regional__card
            Resume(resumeId='detalhes-gerente-regional', :resume='resumeList')
        h3.detalhes-gerente-regional__titulo {{ $t('mensagens.gerenteRegional.labels.dadosVinculados') }}
        .detalhes-gerente-regional__card
            ResumeList(
                resumeId='detalhes-gerente-regional-territoriais',
                :label='$t("mensagens.gerenteRegional.labels.gerentesComerciais")',
                :resume='idsGerentesComerciais'
            )
        .detalhes-gerente-regional__card
            ResumeList(
                resumeId='detalhes-gerente-regional-territoriais',
                :label='$t("mensagens.gerenteRegional.labels.gerentesTerritoriais")',
                :resume='idsGerentesTerritoriais'
            )
        .footer
            .footer__btn.voltar(@click='irParaGerentesRegionais')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
</template>
<script>
import services from '@/services/ContratoOriginacaoService';
import EventBus from '@/utils/eventBus';

export default {
    name: 'DetalhesGerenteRegional',
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        Resume: () =>
            import('@/components/contratosOriginacao/formulario/Resume'),
        ResumeList: () =>
            import('@/components/contratosOriginacao/formulario/ResumeList')
    },
    props: {
        resume: {
            type: [Array, Object],
            default: () => []
        }
    },
    data() {
        return {
            dados: {},
            idsGerentesTerritoriais: [],
            idsGerentesComerciais: [],
            regionais: [],
            gerentesTerritoriais: [],
            gerentesComerciais: []
        };
    },
    computed: {
        resumeList() {
            const keysValids = ['idRegional', 'idBunge', 'nome'];
            const keyMap = keysValids.map(key => ({
                key,
                label: this.$t(`mensagens.gerenteRegional.keys.${key}`),
                value: this.dados[key] || '--'
            }));

            const resume = keyMap.sort(
                (a, b) => keysValids.indexOf(a.key) - keysValids.indexOf(b.key)
            );

            return resume;
        }
    },
    mounted() {
        this.carregarListasGerentes();
    },
    methods: {
        async carregarListasGerentes() {
            this.loadingScreen(true);
            await this.buscarGerentesTerritoriais();
            await this.buscarRegionais();
            await this.buscarGerentesComerciais();
            this.montarDados();
            this.loadingScreen(false);
        },
        montarDados() {
            const gerente = {
                nome: this.resume.nome,
                idBunge: this.resume.idBunge
            };

            this.dados = gerente;
            if (this.resume?.idRegional) {
                const regional = this.regionais.find(
                    regional => regional.id === this.resume.idRegional
                );
                this.dados.idRegional = regional?.nome;
            }
            if (this.resume?.idsGerentesTerritoriais) {
                const idsGerentesTerritoriais =
                    this.gerentesTerritoriais.filter(gerente =>
                        this.resume.idsGerentesTerritoriais.includes(gerente.id)
                    );
                this.idsGerentesTerritoriais = idsGerentesTerritoriais.map(
                    gerente => ({
                        id: gerente.id,
                        value: gerente.nome
                    })
                );
            }
            if (this.resume?.idsGerentesComerciais) {
                const idsGerentesComerciais = this.gerentesComerciais.filter(
                    gerente =>
                        this.resume.idsGerentesComerciais.includes(gerente.id)
                );
                this.idsGerentesComerciais = idsGerentesComerciais.map(
                    gerente => ({
                        id: gerente.id,
                        value: gerente.nome
                    })
                );
            }
        },
        buscarRegionais() {
            return services.buscarRegionais().then(({ data }) => {
                if (data.length > 0) {
                    this.regionais = data;
                }
            });
        },
        buscarGerentesTerritoriais() {
            return services.buscarGerentesTerritoriais().then(({ data }) => {
                if (data.length > 0) {
                    this.gerentesTerritoriais = data;
                }
            });
        },
        buscarGerentesComerciais() {
            return services.buscarGerentesComerciais().then(({ data }) => {
                if (data.length > 0) {
                    this.gerentesComerciais = data;
                }
            });
        },
        irParaGerentesRegionais() {
            this.$router.push({ name: 'GerentesRegionais' });
        },
        loadingScreen(isLoading) {
            const options = {
                mostrarLoading: isLoading,
                lockMessage: this.$t('mensagens.sistema.carregando')
            };
            EventBus.$emit('emit-componente-carregando', options);
        }
    }
};
</script>

<style lang="scss" scoped>
.detalhes-gerente-regional {
    margin: 20px;
    &__titulo {
        margin-top: 24px;
        font-weight: 500;
    }
    &__card {
        margin-top: 10px;
        background-color: $white;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: $default-border-radius;
        @include default-box-shadow();
        & + & {
            margin-top: 20px;
        }
    }
}

.footer {
    display: flex;
    justify-content: flex-end !important;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}
.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
